import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import type { MenuItemProps } from '@mui/material';
import type { ReactNode } from 'react';

export interface BottomMenuItemProps extends MenuItemProps {
  icon: ReactNode;
  label: string;
  href?: string;
  target?: string;
  to?: string;
}

export function BottomMenuItem({
  icon,
  label,
  ...rest
}: Readonly<BottomMenuItemProps>) {
  return (
    <MenuItem {...rest} sx={{ p: 1.5, borderRadius: 2, ...rest.sx }}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText
        sx={{ fontWeight: 500, color: 'var(--blue-grey-1000)' }}
        disableTypography
        primary={label}
      />
    </MenuItem>
  );
}
